import { render, staticRenderFns } from "./cvpage.vue?vue&type=template&id=039f112d&scoped=true&"
import script from "./cvpage.vue?vue&type=script&lang=js&"
export * from "./cvpage.vue?vue&type=script&lang=js&"
import style0 from "./cvpage.vue?vue&type=style&index=0&id=039f112d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "039f112d",
  null
  
)

export default component.exports